<template>
  <mini-player
    v-if="miniPlayer"
    :uid="uid"
    @contextmenu.native.prevent
  />
  <video-player
    v-else-if="!isAudio"
    :uid="uid"
    @contextmenu.native.prevent
  />
  <audio-player
    v-else
    :uid="uid"
    @contextmenu.native.prevent
  />
</template>

<script>
  import Emitter from '../../../mixins/emitter';
  import '../../../../i18n/player';
  import { mapState, mapMutations } from 'vuex';
  import { INIT_PLAYER_DATA } from '../store/rPlayer/mutation-types';
  export default {
    name: 'Player',
    components: {
      VideoPlayer: () =>
        import(/* webpackChunkName: 'video-player' */ './video-player'),
      AudioPlayer: () =>
        import(/* webpackChunkName: 'audio-player' */ './audio-player'),
      MiniPlayer: () =>
        import(/* webpackChunkName: 'mini-player' */ './mini-player')
    },
    mixins: [ Emitter ],
    props: {options: Object, uid: Number},
    computed: {
      ...mapState([
        'isAudio',
        'miniPlayer'
      ])
    },
    watch: {
      options: {
        handler(newVal) {
          this.initPlayerData(newVal);
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      ...mapMutations({
        initPlayerData: INIT_PLAYER_DATA
      })
    }
    // mounted() {
    //   if (!process.env.NODE_ENV !== 'production') {
    //     document.addEventListener('contextmenu', (e) => {
    //       e.stopPropagation();
    //       e.preventDefault();
    //     });
    //   }
    // }
  };
</script>

<style lang="scss">
@import "../index.scss";
</style>
